// @flow
export const LandingPageLocale = {
  hero_unit: {
    header: ["Fast & Reliable Inventory Solutions", "Hızlı & Güvenli Envanter Çözümleri"],
    content: [
      "Count and control your inventory with our technology, according to your needs.",
      "Envanter sayım ve doğrulama ihtiyaçlarınızı karşılayacak teknolojik altyapımızla hizmetinizdeyiz."
    ],
    register_action: ["Join Envanterium", "Envanterium'a Dahil Ol"]
  },
  features_unit: {
    small_header: ["Our Inventory Counting Technology", "Envanter Sayım Teknolojimiz"],
    main_header: [
      "Fast and Secure Inventory Counting with the latest Technology",
      "Hızlı, Güvenli & Teknolojik Envanter Sayımları"
    ],
    main_content: [
      "With our infrastructure that is customizable for your product scale and operational needs, we are ready for all your needs for inventory counting.",
      "Ürün gamınız ve operasyonel gereksinimlerinize göre şekillenen envanter sayım altyapımızla, sayım alanındaki her türlü ihtiyacınızı karşılamaya hazırız."
    ],
    features: {
      technology: {
        header: ["State-of-the-art Technology", "Sürekli Güncel Teknoloji"],
        content: [
          "Our products are constantly maintained and developed with the latest technologies.",
          "Geliştirilmeye devam eden teknolojik altyapımızla sürekli hizmet kalitemizi artırıyoruz."
        ]
      },
      platform: {
        header: ["Platform Independent", "Platform'dan Bağımsız"],
        content: [
          "Our local inventory counting application is developed to work seamlessly with all operating systems.",
          "Lokal sayım takip uygulamamız, tüm işletim sistemlerinde sorunsuz çalışacak şekilde geliştirilmiştir."
        ]
      },
      online: {
        header: ["Online Process Tracking", "Online Sayım Takibi"],
        content: [
          "Before, during and after counting your inventory, you can manage all your data and processes from our online interface.",
          "Sayım öncesi, sırası veya sonrasındaki tüm süreçlerinizi online arayüzümüz ile yönetebilirsiniz."
        ]
      },
      modular: {
        header: ["Modular Usage", "Modüler Kullanım"],
        content: [
          "Each firm has different needs when it comes to inventory-counting, and it is our priority to shape our technology and services according to your needs.",
          "Her firmanın sayım ihtiyaçları birbirinden farklıdır, ihtiyaçlarınızı anlayıp hizmet ve teknolojimizi buna göre şekillendirmek en büyük önceliğimiz."
        ]
      },
      reports: {
        header: ["Dynamic Reporting", "Dinamik Raporlama"],
        content: [
          "With our dynamic reporting infrastructure you can structure your inventory results as you wish.",
          "Dinamik raporlama altyapımızla sayım sonuç raporlarınızı dilediğiniz gibi şekillendirebilirsiniz."
        ]
      },
      support: {
        header: ["Support", "Destek"],
        content: [
          "Our support team is ready for you before, during or after any inventory counting process.",
          "Sayım öncesi, sırası veya sonrasındaki tüm ihtiyaçlarınıza cevap bulabilecek uzman kadromuzla sizlere sürekli hizmet vermekteyiz."
        ]
      }
    }
  },
  lead_generator_unit: {
    header: ["Outsource Your Inventory Counting To Us.", "Envanter Sayımlarınızı Bize Teslim Edebilirsiniz."],
    content: [
      "With our expert team and up-to-date technology, we are ready to detect your inventory counting problems and improve your processes. You can apply to join Envanterium Online right now and start working with us.",
      "Uzman kadromuz ve güncel teknolojimizle envanter sayım süreçlerinizdeki sorunları tespit etmek ve süreçlerinizi geliştirmek için size hizmet etmeye hazırız. Hemen şimdi Envanterium Online talebinizi oluşturarak, bizimle çalışmaya başlayabilirsiniz."
    ],
    action: ["JOIN ENVANTERIUM NOW", "ENVANTERIUM'A HEMEN DAHİL OL"]
  },
  partner_lead_generator_unit: {
    lead: [
      "If you would like to offer your customers inventory counting solutions, you can become our partner and use our infrastructure via our API endpoints.",
      "Müşterilerinize envanter sayımı için çözüm sunmak istiyorsanız, partnerimiz olarak API uç noktalarımız üzerinden tüm altyapımızı kullanabilirsiniz."
    ],
    action: ["MORE INFORMATION", "DAHA FAZLA BİLGİ İÇİN"]
  },
  testimonials_unit: {
    header: {
      title: ["User Reviews", "Müşteri Yorumları"],
      content: ["Reviews from some of our users", "Hizmet verdiğimiz bazı firmaların hakkımızda söyledikleri"]
    }
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicPages/LandingPage.locale.js